module.exports = __webpack_public_path__ + "media/touchstone-horiz.svg";